import { useEffect, useRef } from 'react'
import './LiquidGlassProgressBar.css'

function LiquidGlassProgressBar({ progress = 0, total = 0, current = 0, label = '', isExiting = false }) {
  const progressBarRef = useRef(null)
  const containerRef = useRef(null)
  const percentage = total > 0 ? Math.min(100, Math.max(0, (current / total) * 100)) : 0

  useEffect(() => {
    const element = progressBarRef.current
    if (!element) return

    const handleMouseMove = (e) => {
      const rect = e.currentTarget.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top
      
      const specular = e.currentTarget.querySelector('.progress-specular')
      if (specular) {
        specular.style.background = `radial-gradient(
          circle at ${x}px ${y}px,
          rgba(255,255,255,0.2) 0%,
          rgba(255,255,255,0.05) 30%,
          rgba(255,255,255,0) 60%
        )`
      }
    }
    
    const handleMouseLeave = (e) => {
      const specular = e.currentTarget.querySelector('.progress-specular')
      if (specular) {
        specular.style.background = 'none'
      }
    }
    
    element.addEventListener('mousemove', handleMouseMove)
    element.addEventListener('mouseleave', handleMouseLeave)
    
    return () => {
      element.removeEventListener('mousemove', handleMouseMove)
      element.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, [])

  return (
    <div 
      ref={containerRef}
      className={`liquid-glass-progress-container ${isExiting ? 'progress-exiting' : ''}`}
    >
      {label && (
        <div className="progress-label">
          {label}
        </div>
      )}
      <div className="progress-info">
        <span className="progress-text">
          {current} / {total}
        </span>
        <span className="progress-percentage">
          {percentage.toFixed(0)}%
        </span>
      </div>
      <div 
        ref={progressBarRef}
        className="liquid-glass-progress-bar"
      >
        <div className="progress-filter"></div>
        <div className="progress-overlay"></div>
        <div className="progress-specular"></div>
        <div 
          className="progress-fill"
          style={{ width: `${percentage}%` }}
        >
          <div className="progress-fill-shimmer"></div>
        </div>
        <div className="progress-content">
          <div className="progress-glow"></div>
        </div>
      </div>
    </div>
  )
}

export default LiquidGlassProgressBar

